import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { reducers, effects } from '@unico-people/shared/dashboard/data-access-store';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature('dashboard', reducers), EffectsModule.forFeature(effects)],
  exports: []
})
export class OngoingModule {}
